/* global axios */
import ApiClient from './ApiClient';

export class ServicesAPI extends ApiClient {
  constructor() {
    super('services', { accountScoped: true });
  }

  createSubService(serviceId, subServiceInfo) {
    return axios.post(`${this.url}/${serviceId}/sub_services`, subServiceInfo);
  }

  updateSubService(serviceId, subServiceId, subServiceInfo) {
    return axios.patch(
      `${this.url}/${serviceId}/sub_services/${subServiceId}`,
      subServiceInfo
    );
  }

  deleteSubService(serviceId, subServiceId) {
    return axios.delete(
      `${this.url}/${serviceId}/sub_services/${subServiceId}`
    );
  }
}

export default new ServicesAPI();
